import { render, staticRenderFns } from "./NavigationSectionSubpageSelect.vue?vue&type=template&id=1a1b1fa8&scoped=true&"
import script from "./NavigationSectionSubpageSelect.vue?vue&type=script&lang=ts&"
export * from "./NavigationSectionSubpageSelect.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationSectionSubpageSelect.vue?vue&type=style&index=0&id=1a1b1fa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b1fa8",
  null
  
)

export default component.exports